import { type ReactNode, useEffect } from 'react'

import { Footer } from '../footer'
import { Sidebar } from '../sidebar'
import { WorkspaceStatusBanner } from '../workspace-status-banner'
import { VerticalLayoutHeader } from './vertical-layout-header'

export function VerticalLayout({ children }: { children: ReactNode }) {
  // This shell is viewport-locked (h-svh; only <main> scrolls). Lock the document's
  // OWN scroll too while it's mounted, so a body-level overlay that extends the page
  // (e.g. the dev devtools panel, a portal) can't let the window over-scroll past the
  // footer — which makes the footer look "very tall" with empty space below. Restored
  // on unmount so the horizontal layout / login (which use body-scroll) are unaffected.
  useEffect(() => {
    const el = document.documentElement
    const prev = el.style.overflow
    el.style.overflow = 'hidden'
    return () => {
      el.style.overflow = prev
    }
  }, [])

  return (
    <>
      <Sidebar />
      {/* App-shell scroll: the column is pinned to the viewport height and only
          <main> scrolls, so the header (top) and Footer (bottom) stay in view —
          like the record-nav. */}
      <div className="flex h-svh w-full flex-col overflow-hidden">
        <VerticalLayoutHeader />
        {/* Renders nothing when the workspace is active. When paused
            or pending_deletion it sits between the header and main
            content so it's the first thing the user sees. */}
        <WorkspaceStatusBanner />
        <main className="flex-1 overflow-y-auto">{children}</main>
        <Footer />
      </div>
    </>
  )
}
